import React, { useState } from 'react';
import { MdModeEditOutline, MdDelete } from 'react-icons/md';
import AdminEditProduct from './AdminEditProduct';
import displayINRCurrency from '../helpers/displayCurrency';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import fetchCategoryWiseProduct from '../helpers/fetchCategoryWiseProduct';
import SummaryApi from '../common'
import { toast } from 'react-toastify'
import defaultImage from '../assest/DAWACO_Icon.png'; 

const AdminCosmeticVerticalCard = ({ userType,loading, data = [] }) => {
    const loadingList = new Array(13).fill(null);
    const [editProduct, setEditProduct] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [productToDelete, setProductToDelete] = useState(null);
    const query = useLocation();

    const openEditProduct = (product) => {
        setSelectedProduct(product);
        setEditProduct(true);
    };

    const handleDeleteClick = (product) => {
        setProductToDelete(product);
        setShowDeleteConfirmation(true);
    };

    const deleteProduct = async (id) => {
        try {
            const response = await fetch(SummaryApi.deleteProduct.url, {
              method: SummaryApi.deleteProduct.method,
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: id,
                type:"Cosmetic"
              }),
            });
      
            const responseData = await response.json();
      
            if (responseData.success) {
                toast.success('تم حدف المنتج بنجاح');
                setShowDeleteConfirmation(false);
                window.location.reload();
                
            
            }  else {
                toast.error('خطأ في حذف المنتج');
            }
          } catch (error) {
            toast.error('حدث خطأ');
          }
          
    };

    return (
        <div className='grid grid-cols-[repeat(auto-fit,minmax(260px,300px))] justify-center md:justify-between md:gap-4 overflow-x-scroll scrollbar-none transition-all'>
            {loading ? (
                loadingList.map((_, index) => (
                    <div className='w-full min-w-[280px] md:min-w-[320px] max-w-[280px] md:max-w-[320px] bg-white rounded-sm shadow' key={index}>
                        <div className='bg-slate-200 h-48 p-4 min-w-[280px] md:min-w-[145px] flex justify-center items-center animate-pulse'></div>
                        <div className='p-4 grid gap-3'>
                            <h2 className='font-medium text-base md:text-lg text-ellipsis line-clamp-1 text-black p-1 py-2 animate-pulse rounded bg-slate-200'></h2>
                            <p className='capitalize text-slate-500 p-1 animate-pulse rounded bg-slate-200 py-2'></p>
                            <div className='flex gap-3'>
                                <p className='text-blue-600 font-medium p-1 animate-pulse rounded bg-slate-200 w-full py-2'></p>
                                <p className='text-slate-500 line-through p-1 animate-pulse rounded bg-slate-200 w-full py-2'></p>
                            </div>
                            <button className='text-sm text-white px-3 rounded bg-slate-200 py-2 animate-pulse'></button>
                        </div>
                    </div>
                ))
            ) : (
                data.map((product) => {
                    return (
                        <div key={product?._id} className='w-full min-w-[280px] md:min-w-[300px] max-w-[280px] md:max-w-[300px] bg-white rounded-sm shadow'>
                             <Link to={`/admin-cosmetic-product/${product?._id}`} >
                                <div className='bg-slate-200 h-48 p-4 min-w-[280px] md:min-w-[145px] flex justify-center items-center'>
                                    <img src={product?.productImage[0] || defaultImage} className='object-scale-down h-full hover:scale-110 transition-all mix-blend-multiply' alt={product?.productName} />
                                </div>
                            </Link>
                            <div className='p-4 grid gap-3  relative'>
                            <Link to={`/admin-cosmetic-product/${product?._id}`} >
                                    <h2 className='font-medium text-base text-ellipsis overflow-hidden whitespace-nowrap'>{product?.productName}</h2>
                                    <p className='capitalize text-slate-500'>{product?.category} : العلامة التجارية</p>
                                    <p className='capitalize text-slate-500'>{product?.activePharmaceuticalIngredient} : الماده الفعالة</p>
                                    <p className='capitalize text-slate-500'> {product?.quantity} : الكمية</p>
                                    <p className='capitalize text-slate-500'>
                                   النوع  : {product?.status === "Promo Pack" ? "العروض المجمعة" :
                                    product?.status === "New Arrival" ? "منتجات حديثة الوصول" :
                                    product?.status === "Sale" ? "التخفيضات" :
                                    product?.status === "Default" ? "افتراضي" :
                                    product?.status} 
                                    </p>

                                    <div className='flex gap-3'>
                                        {product.sellingPrice > 0 ? (
                                            <>
                                                <p className='text-blue-800 font-medium'>{displayINRCurrency(product.sellingPrice)}</p>
                                                <p className='text-slate-500 line-through'>{displayINRCurrency(product.price)}</p>
                                            </>
                                        ) : (
                                            <p className='text-blue-800 font-medium'>{displayINRCurrency(product.price)}</p>
                                        )}
                                    </div>
                                </Link>
                                <div className='absolute top-2 right-2 flex space-x-2'>
                                    <div className='p-2 bg-blue-100 hover:bg-blue-800 rounded-full hover:text-white cursor-pointer' onClick={() => openEditProduct(product)}>
                                        <MdModeEditOutline />
                                    </div>
                                    <div className='p-2 bg-red-100 hover:bg-red-800 rounded-full hover:text-white cursor-pointer' onClick={() => handleDeleteClick(product)}>
                                        <MdDelete />
                                    </div>
                                </div>
                                {product?.quantity <= 0 ? (
                                    <span className='text-sm text-red-500 mt-2'>غير متاح حاليا في المخزن</span>
                                ) : (
                                   <></>
                                )}
                            </div>
                        </div>
                    );
                })
            )}
            {/* Modal for Editing Product */}
            {editProduct && (
                <div className='fixed inset bg-black bg-opacity-50 flex items-center justify-center z-50'>
                    <div className='bg-white p-8 rounded-lg shadow-lg w-full max-w-3xl relative'>
                        <AdminEditProduct userType={userType} productData={selectedProduct} onClose={() => setEditProduct(false)} fetchdata={fetchCategoryWiseProduct} condition={true} />
                    </div>
                </div>
            )}
            {/* Modal for Delete Confirmation */}
            {showDeleteConfirmation && (
                <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'>
                    <div className='bg-white p-8 rounded-lg shadow-lg w-full max-w-md'>
                        <h2 className='text-lg font-semibold mb-4'>Are you sure you want to delete {productToDelete?.productName}?</h2>
                        <div className='flex justify-end space-x-4'>
                            <button className='px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700' onClick={()=>deleteProduct(productToDelete._id)}>Yes</button>
                            <button className='px-4 py-2 bg-gray-300 text-black rounded-md hover:bg-gray-400' onClick={() => setShowDeleteConfirmation(false)}>No</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminCosmeticVerticalCard;
